export default __webpack_public_path__ + "static/media/astar.5651f0ab.svg";